type Environments = "dev" | "test" | "demo" | "prod";

export function detectEnvironment(): Environments {
  if (import.meta.env.DEV) {
    if (window && "localStorage" in window) {
      const storedEnv = localStorage.getItem("env");
      if (storedEnv && (storedEnv === "dev" || storedEnv === "test" || storedEnv === "demo" || storedEnv === "prod")) {
        return storedEnv as Environments;
      }
    }
    return "dev";
  }
  if (import.meta.env.VITE_TEST) return "test";
  if (import.meta.env.VITE_DEMO) return "demo";
  return "prod";
}

type Config = {
  environmentName: Environments;
  apiBaseUrl: string;
  socketsUrl: string;
  marketplaceUrl: string;
  manageUrl: string;
  cookieDomain: string | undefined;
  mapboxPublicAccessToken: string;
  features: {
    pagedVariantEditor: boolean;
    supporterCreditCards: boolean;
    deliveryPricing: boolean;
    eapCategories: boolean;
    extraEapFilters: boolean;
    budgetTypes: boolean;
    onlineListingsOnly: boolean;
  };
};

const MAPBOX_BEN = "pk.eyJ1IjoiZ2l2ZW53ZWxsYmVuIiwiYSI6ImNsbnNjZnhidjB5OXEyc253c3A2ZXpnYXUifQ.ImW-5vpX25P2j7pp05baKg";

const CONFIG: Record<Environments, Config> = {
  dev: {
    environmentName: "dev",
    apiBaseUrl: `https://${location.hostname}:3000`,
    socketsUrl: `https://${location.hostname}:3200`,
    marketplaceUrl: `https://${location.hostname}:${location.port}`,
    manageUrl: `https://${location.hostname}:${location.port}`,
    cookieDomain: undefined,
    mapboxPublicAccessToken: MAPBOX_BEN,
    features: {
      pagedVariantEditor: false,
      supporterCreditCards: false,
      deliveryPricing: false,
      eapCategories: true,
      extraEapFilters: true,
      budgetTypes: false,
      onlineListingsOnly: false,
    },
  },
  test: {
    environmentName: "test",
    apiBaseUrl: "https://api.test.givenwell.com",
    socketsUrl: "https://events.test.givenwell.com",
    marketplaceUrl: "https://app.test.givenwell.com",
    manageUrl: "https://manage.test.givenwell.com",
    cookieDomain: ".test.givenwell.com",
    mapboxPublicAccessToken: MAPBOX_BEN,
    features: {
      pagedVariantEditor: false,
      supporterCreditCards: true,
      deliveryPricing: false,
      eapCategories: true,
      extraEapFilters: true,
      budgetTypes: false,
      onlineListingsOnly: false,
    },
  },
  demo: {
    environmentName: "demo",
    apiBaseUrl: "https://api.demo.givenwell.com",
    socketsUrl: "https://events.demo.givenwell.com",
    marketplaceUrl: "https://app.demo.givenwell.com",
    manageUrl: "https://manage.demo.givenwell.com",
    cookieDomain: ".demo.givenwell.com",
    mapboxPublicAccessToken: MAPBOX_BEN,
    features: {
      pagedVariantEditor: false,
      supporterCreditCards: true,
      deliveryPricing: false,
      eapCategories: true,
      extraEapFilters: true,
      budgetTypes: false,
      onlineListingsOnly: true,
    },
  },
  prod: {
    environmentName: "prod",
    apiBaseUrl: "https://api.givenwell.com",
    socketsUrl: "https://events.givenwell.com",
    marketplaceUrl: "https://app.givenwell.com",
    manageUrl: "https://manage.givenwell.com",
    cookieDomain: ".givenwell.com",
    mapboxPublicAccessToken: MAPBOX_BEN,
    features: {
      pagedVariantEditor: false,
      supporterCreditCards: true,
      deliveryPricing: false,
      eapCategories: true,
      extraEapFilters: true,
      budgetTypes: false,
      onlineListingsOnly: false,
    },
  },
};

export const config = CONFIG[detectEnvironment()];
